import React, { ReactElement } from 'react';
import { Tooltip } from 'antd';

interface Props {
  title: string;
  children: ReactElement;
}

/**
 * Header icons sit on the top edge of the panel, so the tip opens downward
 * and stays inside the chat. The span is the tooltip trigger so a disabled
 * button still shows it.
 */
const BotHeaderTooltip: React.FC<Props> = ({ title, children }) => (
  <Tooltip title={title} placement="bottom">
    <span className="bot-header-tip">{children}</span>
  </Tooltip>
);

export default BotHeaderTooltip;
